import * as t from 'io-ts';

import {makeEnumRuntimeType} from '../../../shared/helpers/src/typescript/enumHelpers';

/*
 * Runtime types.
 */

export enum KnowledgeBaseParametersTypesEnum {
  ARTICLE = 'ARTICLE',
  LIST = 'LIST',
  SETTINGS = 'SETTINGS',
}

const RKnowledgeBaseParametersType = makeEnumRuntimeType(KnowledgeBaseParametersTypesEnum);

/*
 * Base.
 */

export const RKnowledgeBaseRouteLocation = t.type({
  pathname: t.string,
});

const RKnowledgeBaseParametersBase = t.type({
  type: RKnowledgeBaseParametersType,
  location: RKnowledgeBaseRouteLocation,
});

/*
 * Page parameters.
 */

const RKnowledgeBaseArticleParameters = t.intersection([
  RKnowledgeBaseParametersBase,
  t.type({
    type: t.literal(KnowledgeBaseParametersTypesEnum.ARTICLE),
    articleId: t.number,
  }),
]);

const RKnowledgeBaseListParameters = t.intersection([
  RKnowledgeBaseParametersBase,
  t.type({
    type: t.literal(KnowledgeBaseParametersTypesEnum.LIST),
  }),
]);

const RKnowledgeBaseSettingsParameters = t.intersection([
  RKnowledgeBaseParametersBase,
  t.type({
    type: t.literal(KnowledgeBaseParametersTypesEnum.SETTINGS),
  }),
]);

/*
 * Union of parameters.
 */

export const RKnowledgeBaseParameters = t.taggedUnion('type', [
  RKnowledgeBaseArticleParameters,
  RKnowledgeBaseListParameters,
  RKnowledgeBaseSettingsParameters,
]);

/*
 * Types.
 */

export interface KnowledgeBaseArticleParameters
  extends Readonly<t.TypeOf<typeof RKnowledgeBaseArticleParameters>> {}

export interface KnowledgeBaseListParameters
  extends Readonly<t.TypeOf<typeof RKnowledgeBaseListParameters>> {}

export interface KnowledgeBaseSettingsParameters
  extends Readonly<t.TypeOf<typeof RKnowledgeBaseSettingsParameters>> {}

export type KnowledgeBaseParameters =
  | KnowledgeBaseArticleParameters
  | KnowledgeBaseListParameters
  | KnowledgeBaseSettingsParameters;
